import { render, staticRenderFns } from "./CartRecommendBanner.vue?vue&type=template&id=7634ae31&scoped=true&"
import script from "./CartRecommendBanner.vue?vue&type=script&lang=ts&"
export * from "./CartRecommendBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CartRecommendBanner.vue?vue&type=style&index=0&id=7634ae31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634ae31",
  null
  
)

export default component.exports